import styled from 'styled-components'

export const Title = styled.h3`
  display: inline-block;
  padding: .5em 1em;
  position: relative;
  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  margin-bottom: 0.75rem;
`
